import "./TopFold.css";
import { Link } from "react-router-dom";
import { LuBookOpen, LuHeadphones, LuBrain } from "react-icons/lu";
import topfoldImage from "../../assets/images/image-topfold.png";

const TopFold = () => {
  return (
    <div className="topfold-container">
      <div className="topfold-content">
        {/* Left: Text */}
        <div className="topfold-left">
          <p className="eyebrow"></p>{/* usually here: 🇧🇷 Feito para brasileiros */}
        <h1 className="topfold-heading">
          <span className="topfold-line-1">
            <span className="shiny-text-topfold">Aprenda</span> um idioma
          </span>
          <span className="topfold-line-2">com histórias</span>
          <span className="script-highlight">sem se perder</span>
        </h1>


          <p className="topfold-subheader">
          Leia e escute conteúdo real, 
          {/* <span className="subtle-highlight">com apenas 1 história por dia</span>. */}
          </p>

          <p className="topfold-subheader">
             com tradução em português.
          </p>

          {/* <div className="hero-badges">
            <span className="badge">
              <LuBookOpen className="badge-icon" />
              Conteúdo
            </span>
            <span className="badge">
              <LuHeadphones className="badge-icon" />
              Audio
            </span>
            <span className="badge">
              <LuBrain className="badge-icon" />
              Flashcards
            </span>
          </div> */}

        <div className="hiw__cta">
        <button
          className="topfold-cta"
          data-tally-open="mYN7Dz"
          data-tally-layout="modal"
          data-tally-hide-title="1"
          onClick={() => {
            if (!window.Tally) window.open("https://tally.so/r/mYN7Dz", "_blank", "noopener,noreferrer");
          }}
        >
          Entre na lista
        </button>
        </div>

        {/* <div className="brasil-badge">
          🇧🇷 Feito para brasileiros
        </div> */}

          {/* <div className="hiw__cta">
            <Link to="/signup" className="topfold-cta">
            Comece grátis
            </Link>
          </div> */}
          {/* <div className="cta-note">
            <span className="checkmark">✓</span>
            Sem cartão de crédito     
          </div> */}
        </div>


        {/* Right: Image */}
        <div className="topfold-right">
          <img
            src={topfoldImage}
            alt="App preview"
            className="topfold-image"
          />
        </div>
      </div>
    </div>
  );
};

export default TopFold;


